export function isWorkoutLogEnabled(value = process.env.REACT_APP_WORKOUT_LOG_ENABLED) {
  return value === "true";
}
